import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CelIconButtonPopoverInterface as PopoverConfig } from '@savvaslearning/cel-components/dist-stencil/loader';
import { CelIconSizes, DomainDropdownOptions } from '../../models/common.model';
import { IconDetails } from '../../models/constants';
import { SharedService } from '../../services/shared.service';
@Component({
  selector: 'app-growth-score-card',
  templateUrl: './growth-score-card.component.html',
  styleUrls: ['./growth-score-card.component.scss'],
})
export class GrowthScoreCardComponent implements OnChanges {
  isLoading$ = this.sharedService.isLoading$;
  @Input() cardTitle: string;
  @Input() cardScore: number;
  @Input() cardMessage: string;
  @Input() dropdownProperties: DomainDropdownOptions = {
    dropdownMenu: [],
    selectedOption: null,
  };
  @Input() isDashVisible: boolean;
  @Output() updatedDropdownValue = new EventEmitter<string>();
  @Input() showDomainDropdown: boolean;
  @Input() showZeroStateMessage: boolean;
  @Input() isStudentMetric = false;
  @Input() isClassMetric = false;
  @Input() studentScorePopoverMessage: string;

  iconDetails = IconDetails;
  popoverConfig: PopoverConfig = {
    closeIconSize: CelIconSizes.REGULAR,
    preventReturnFocusOnTabForwards: false,
  };
  shouldFocusInfoIcon = false;

  constructor(private readonly sharedService: SharedService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.studentScorePopoverMessage) {
      this.updatePopoverLabel();
    }
  }

  private updatePopoverLabel(): void {
    this.popoverConfig = {
      ...this.popoverConfig,
      label: this.studentScorePopoverMessage,
    };
  }

  domainSelectionChange(event: CustomEvent): void {
    this.updatedDropdownValue.emit(event.detail.identifier);
    this.dropdownProperties.selectedOption = null;
  }

  setInfoIconFocus(shouldFocusElement: boolean): void {
    this.shouldFocusInfoIcon = shouldFocusElement;
  }
}
